import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, isRef as _isRef, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-7dbfc251"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-body-sec1" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = {
  for: "id",
  class: "control-label input-label-form"
}
const _hoisted_9 = ["placeholder", "onKeydown"]
const _hoisted_10 = ["v-if"]
const _hoisted_11 = { class: "help-text" }
const _hoisted_12 = { class: "letsgo-btn" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_15 = { class: "modal-content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "modal-body !tw-pr-[55px] !tw-pl-[71px] !tw-pt-[34px] !tw-pb-[56px]" }
const _hoisted_19 = { class: "modal-body-sec1" }
const _hoisted_20 = { class: "form-group !tw-mt-[32px] !tw-mb-[27px]" }
const _hoisted_21 = { class: "control-label input-label-form !tw-mt-[0px] !tw-mb-[22px]" }
const _hoisted_22 = { class: "tw-flex tw-items-center" }
const _hoisted_23 = { class: "form-control form-control-lg form-input !tw-w-fit" }
const _hoisted_24 = { class: "letsgo-btn !tw-mt-0" }
const _hoisted_25 = ["disabled"]

import ErrorHandler from "@/components/common/exceptionHandler.vue";
import utilities from "@/utils/utilities";
import userService from "@/services/user/userService";
import { onBeforeUnmount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import store from "@/store";
import CopyInfo from "../../common/copyInfo.vue";
import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";


export default /*#__PURE__*/_defineComponent({
  __name: 'forgotPasswordContain',
  setup(__props) {

const showProspectCallbackError = ref(false);
const prospectCallbackErrorMsg = ref("");
const email = ref("");
const emailForgotPassword = ref("");
const isPositiveNotification = ref(false);
const isLoading = ref(false);
const passwordResetModal: any = ref<null>(null);
const isShowResetModal: any = ref(true);
const isShowSecretModal: any = ref(false);
const passwordSecretModal: any = ref<null>(null);
const secret = ref("");
const emailPlaceholder = ref("");
const emailFieldFocus = ref(0);
const emailValid = ref(true);
const emailValidationMsg = ref("");
const disableButton = ref(true);

const router = useRouter();

const languageSelected = ref(store.state.LanguagePicker.languageSelected);
const defaultUiText = ref(store.state.LanguagePicker.defaultUiText);
const languageSelectedText = ref(
  store.state.LanguagePicker.languageSelectedText,
);
let loginErrorMsg = ref("");

const onResize = () => {
  emailForgotPassword.value && emailForgotPassword?.value?.focus();
};

const getUiText = (id, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const inputBlur = (inputIs: string, isBlur = false, val) => {
  if (isBlur) {
    emailFieldFocus.value++;
  }
  if (inputIs === "EMAIL" && emailFieldFocus.value > 0) {
    if (!Utils.IsEmailValid(isBlur ? emailForgotPassword.value : val)) {
      emailValid.value = false;
      emailValidationMsg.value = getUiText("app-prospect-error-invalid-email");
    } else {
      emailValid.value = true;
      emailValidationMsg.value = "";
    }
  }
  checkFormVals();
};

const checkFormVals = () => {
  if (
    emailForgotPassword.value === "" ||
    emailValid.value === false ||
    !Utils.IsEmailValid(emailForgotPassword.value)
  ) {
    disableButton.value = true;
  } else {
    disableButton.value = false;
  }
};

const resetShowProspectCallbackError = (props) => {
  const { isSuccess } = props;
  showProspectCallbackError.value = false;
  prospectCallbackErrorMsg.value = "";
  if (isSuccess) {
    isLoading.value = false;
    isShowResetModal.value = false;
    isShowSecretModal.value = true;
  }
};

const onCloseSecretModal = () => {
  isShowSecretModal.value = false;
  secret.value = "";
  isShowResetModal.value = true;
};

const onClickCompleteSecret = () => {
  isShowSecretModal.value = false;
  secret.value = "";
  isShowResetModal.value = true;
  router.push({ path: "/user/login" });
};

const submit = () => {
  if (emailForgotPassword.value === "") {
    return showErrorInfo({
      message: "Please enter your CyberSystem email address",
    });
  }

  if (utilities.IsEmailValid(emailForgotPassword.value) === false) {
    return showErrorInfo({
      message: "Please enter a valid emailForgotPassword address",
    });
  }
  isLoading.value = true;

  const data = {
    emailForgotPassword: emailForgotPassword.value,
  };
  return forgotPasswordApi(data);
};

const getRecaptcha = async () => {
  try {
    const finalKey = await Utils.getV3Recaptcha();
    const recaptcha = await load(`${finalKey}`, {
      autoHideBadge: true,
    });
    const token = await recaptcha.execute("submit");
    return token;
  } catch (error: any) {
    console.log(error);
  }
};

const forgotPasswordApi = async (data: any) => {
  try {
    const recaptcha = await getRecaptcha();
    const res: any = await userService.forgotPassword(
      data.emailForgotPassword,
      recaptcha,
    );
    secret.value = res.data.data.secret;
    showToastMessage(res.data.furtherDetails, ToastVariant.SUCCESS);
  } catch (error: any) {
    isLoading.value = false;
    if (error && error.data && error.data.error && error.data.error.type) {
      if (error.data.error.type === "exc_session_invalid-1") {
        sessionStorage.setItem(
          "prospectCallbackErrorInfo",
          JSON.stringify(error.data.error),
        );
        router.push({ path: "/" });
      } else {
        showToastMessage(error.data.error.message, ToastVariant.ERROR);
      }
    } else {
      showErrorInfo(error.data);
    }
  }
};
const showErrorInfo = (errorInfo, stateIsPositiveNotification = false) => {
  if (errorInfo && errorInfo !== "") {
    isPositiveNotification.value = stateIsPositiveNotification;
    errorInfo =
      typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;

    if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
      showProspectCallbackError.value = true;
      prospectCallbackErrorMsg.value = errorInfo.message;
    }
  }
};

const showToastMessage = (message: string, variant: ToastVariant) => {
  const emitData: IToastMessage = {
    variant,
    message,
  };
  eventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const onClickClose = () => {
  router.go(-1);
};

const beforeUnmount = () => {
  if (document.body.classList.contains("page-opacity")) {
    document.body.classList.remove("page-opacity", "page-bg", "page-shadow");
  }
};

onMounted(() => {
  onResize();
  window.addEventListener("resize", onResize);
  if (!document.body.classList.contains("page-opacity")) {
    onResize();
    document.body.classList.add("page-opacity", "page-bg");
  }
  emailPlaceholder.value = getUiText("app-user-login-username-prompt-1");
});

onBeforeUnmount(() => {
  beforeUnmount();
  window.removeEventListener("resize", onResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showProspectCallbackError.value || null)
      ? (_openBlock(), _createBlock(ErrorHandler, {
          key: 0,
          "prospect-callback-error-msg": prospectCallbackErrorMsg.value,
          "is-positive": isPositiveNotification.value,
          onResetShowProspectCallbackError: resetShowProspectCallbackError
        }, null, 8, ["prospect-callback-error-msg", "is-positive"]))
      : _createCommentVNode("", true),
    (isShowResetModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: "passwordResetModal",
          ref_key: "passwordResetModal",
          ref: passwordResetModal,
          class: "modal fade password-reset-modal tw-block show",
          "aria-labelledby": "passwordResetModalLabel"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", { class: "modal-header" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  "aria-label": "Close",
                  onClick: onClickClose
                }, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(getUiText("app-user-forgot-password-heading-1")), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(getUiText("app-user-forgot-password-email-heading-1")), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    ref_key: "email",
                    ref: email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailForgotPassword).value = $event)),
                    "data-cy": "forgot-password-page-email-input",
                    type: "email",
                    class: _normalizeClass([!emailValid.value ? 'invalid-input' : '', "form-control form-control-lg form-input"]),
                    tabindex: "0",
                    placeholder: emailPlaceholder.value,
                    onKeydown: _withKeys(submit, ["enter"]),
                    onBlur: _cache[1] || (_cache[1] = ($event: any) => (inputBlur('EMAIL', true, emailForgotPassword.value))),
                    onInput: _cache[2] || (_cache[2] = 
                (e) => {
                  _isRef(loginErrorMsg) //@ts-ignore
 ? loginErrorMsg.value = '' : loginErrorMsg = '';
                  inputBlur(
                    'EMAIL',
                    false,
                    (e.target as HTMLInputElement).value || '',
                  );
                }
              )
                  }, null, 42, _hoisted_9), [
                    [_vModelText, emailForgotPassword.value]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["error-msg", !emailValid.value ? 'mg-top-19' : '']),
                    "v-if": !emailValid.value || null
                  }, [
                    _createElementVNode("span", null, _toDisplayString(emailValidationMsg.value), 1)
                  ], 10, _hoisted_10)
                ]),
                _createElementVNode("div", _hoisted_11, _toDisplayString(getUiText("app-user-forgot-password-email-help-text-1")), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    "data-cy": "forgot-password-page-submit-button",
                    class: "btn btn-primary letsgo-button",
                    tabindex: "3",
                    disabled: disableButton.value,
                    onClick: submit
                  }, _toDisplayString(getUiText("app-user-forgot-password-reset-button-text-1")), 9, _hoisted_13)
                ])
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true),
    (isShowSecretModal.value || secret.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          id: "passwordSecretModal",
          ref_key: "passwordSecretModal",
          ref: passwordSecretModal,
          class: "modal fade password-reset-modal tw-block show",
          "aria-labelledby": "passwordResetModalLabel"
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", { class: "modal-header" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  "aria-label": "Close",
                  onClick: onCloseSecretModal
                }, _hoisted_17)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(getUiText("user-reset-password-secret-title-1")), 1),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(getUiText("user-reset-password-secret-description-1")), 1),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(secret.value), 1),
                    _createVNode(CopyInfo, {
                      class: "copy-info-container tw-bg-[#FFFFFF] tw-rounded-md !tw-ml-[15px]",
                      text: secret.value ? secret.value : '',
                      "style-icon-css": 'tw-w-[18px] tw-h-[18px]',
                      "is-show-text": false
                    }, null, 8, ["text"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary letsgo-button !tw-w-[137px]",
                    tabindex: "3",
                    disabled: disableButton.value,
                    onClick: onClickCompleteSecret
                  }, _toDisplayString(getUiText("app-profile-modal-update-email-address-button-1")), 9, _hoisted_25)
                ])
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true)
  ], 64))
}
}

})